import React from 'react';
import { HORIZONTAL_BANNER_SIZE } from '../types';

interface ITitleProps {
  size?: HORIZONTAL_BANNER_SIZE;
  children: React.ReactNode;
}

export const Title: React.FC<ITitleProps> = ({
  size = HORIZONTAL_BANNER_SIZE.RESPONSIVE,
  children,
}) => {
  const isResponsive = size === HORIZONTAL_BANNER_SIZE.RESPONSIVE;

  return (
    <span
      className={`tw-lf-title-xs tw-self-start ${
        isResponsive ? 'desktop:tw-lf-title-sm' : ''
      }`}
    >
      {children}
    </span>
  );
};
